import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { InsuranceCertificateStatus } from 'src/app/interfaces/insurance-certificate-status';
import { atLeastOneSelectionValidator } from 'src/app/validators/at-least-one-selection-validator';

import { CompanyVendorFileForm } from './company-vendor-file-form';
import { InsurancePolicyForm } from './insurance-policy-form';

export class InsuranceCertificateForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyVendorId: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  InsuranceAgentId: FormControl<number | undefined>;
  ancestryId: FormControl<string | undefined>;
  isCertAndSigned: FormControl<boolean>;
  viveNamedCertHolder: FormControl<boolean>;
  agentSigned: FormControl<boolean>;
  isLegalNameVerified: FormControl<boolean>;
  desOfOps: FormControl<boolean | undefined>;
  status: FormControl<InsuranceCertificateStatus | undefined>;
  statusDate: FormControl<Date | undefined>;
  prodName: FormControl<string | null>;
  prodAddress: FormControl<string | null>;
  prodAddress2: FormControl<string | null>;
  prodCity: FormControl<string | null>;
  prodState: FormControl<string | null>;
  prodZip: FormControl<string | null>;
  prodPhone: FormControl<string | null>;
  prodPhoneExt: FormControl<string | null>;
  prodEmail: FormControl<string | null>;
  contactName: FormControl<string | undefined>;
  contactPhone: FormControl<string | undefined>;
  contactFax: FormControl<string | null>;
  contactEmail: FormControl<string | undefined>;
  contactAddress: FormControl<string | null>;
  contactCity: FormControl<string | null>;
  contactState: FormControl<string | null>;
  contactZip: FormControl<string | null>;
  agentFirstName: FormControl<string | undefined>;
  agentLastName: FormControl<string | undefined>;
  agentCompany: FormControl<string | null>;
  agentPhone: FormControl<string | null>;
  agentPhoneExt: FormControl<string | null>;
  agentAddress: FormControl<string | null>;
  agentAddress2: FormControl<string | null>;
  agentCity: FormControl<string | null>;
  agentState: FormControl<string | null>;
  agentZip: FormControl<string | null>;
  agentEmail: FormControl<string | undefined>;
  isPaused: FormControl<boolean | undefined>;
  pauseDate: FormControl<Date | null>;
  pauseReason: FormControl<string | null>;
  wasMigrated: FormControl<boolean | undefined>;
  rejectedReason: FormControl<string | null>;
  scanJson: FormControl<any | null>;
  acceptNonRatedAMBestRating: FormControl<boolean>;

  InsurancePolicies: FormArray<InsurancePolicyForm>;
  CompanyVendorFiles: FormArray<CompanyVendorFileForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyVendorId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      VendorId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      CompanyId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      InsuranceAgentId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      ancestryId: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      isCertAndSigned: new FormControl<boolean>(false, { nonNullable: true }),
      viveNamedCertHolder: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      agentSigned: new FormControl<boolean>(false, { nonNullable: true }),
      isLegalNameVerified: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      desOfOps: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      status: new FormControl<InsuranceCertificateStatus | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      statusDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      prodName: new FormControl<string | null>(null),
      prodAddress: new FormControl<string | null>(null),
      prodAddress2: new FormControl<string | null>(null),
      prodCity: new FormControl<string | null>(null),
      prodState: new FormControl<string | null>(null),
      prodZip: new FormControl<string | null>(null),
      prodPhone: new FormControl<string | null>(null),
      prodPhoneExt: new FormControl<string | null>(null),
      prodEmail: new FormControl<string | null>(null),
      contactName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      contactPhone: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      contactFax: new FormControl<string | null>(null),
      contactEmail: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      contactAddress: new FormControl<string | null>(null),
      contactCity: new FormControl<string | null>(null),
      contactState: new FormControl<string | null>(null),
      contactZip: new FormControl<string | null>(null),
      agentFirstName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      agentLastName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      agentCompany: new FormControl<string | null>(null),
      agentPhone: new FormControl<string | null>(null),
      agentPhoneExt: new FormControl<string | null>(null),
      agentAddress: new FormControl<string | null>(null),
      agentAddress2: new FormControl<string | null>(null),
      agentCity: new FormControl<string | null>(null),
      agentState: new FormControl<string | null>(null),
      agentZip: new FormControl<string | null>(null),
      agentEmail: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      isPaused: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      pauseDate: new FormControl<Date | null>(null),
      pauseReason: new FormControl<string | null>(null),
      wasMigrated: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      rejectedReason: new FormControl<string | null>(null),
      scanJson: new FormControl<any | null>(null),
      acceptNonRatedAMBestRating: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      InsurancePolicies: new FormArray<InsurancePolicyForm>([]),
      CompanyVendorFiles: new FormArray<CompanyVendorFileForm>([], {
        validators: [atLeastOneSelectionValidator]
      })
    });
  }
}
